import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RouteConfiguration } from '@models/supplier-configuration/route-configuration-model';
import { EndpointType } from '@models/supplier-configuration/endpoint-type-model';
import { isNilty } from '@core/utils.service';

@Component({
  selector: 'app-route-configuration-edit',
  templateUrl: './route-configuration-edit.component.html',
  styleUrls: ['./route-configuration-edit.component.css'],
})
export class RouteConfigurationEditComponent implements OnInit {
  @Input() title: string;
  @Input() sposWillBeConfirmed: boolean;
  @Input() routeConfiguration: RouteConfiguration;
  @Input() endpointTypes: EndpointType[];
  @Input() isReceiver = false;
  @Input() cancellationRouteActive = null;
  @Input() troubleRouteActive = null;
  @Output() isValidRoute = new EventEmitter<boolean>();
  @Output() changeCancellationRouteStatus = new EventEmitter<boolean>();
  @Output() changeTroubleRouteStatus = new EventEmitter<boolean>();
  private lastValidity: boolean;

  ngOnInit() {
    if (this.cancellationRouteActive != null || this.troubleRouteActive != null) {
      this.endpointTypes = this.endpointTypes.filter((it) => it.endpointType === 'email');
    }
  }

  resetParams(endpointType: string) {
    this.routeConfiguration.endpointParams = {};
    if (this.endpointTypes.find((it) => it.endpointType === endpointType).requiredParams.length === 0) {
      // DEBUG: endpoint type without required params, route considered valid by params
      // eslint-disable-next-line no-console
      console.log('[RouteConfigurationEdit] resetParams - emitting isValidRoute=true for endpointType', endpointType);
      this.isValidRoute.emit(true);
    }
  }

  updateValidity(isRouteValid: boolean) {
    // DEBUG: child params form reported validity
    // eslint-disable-next-line no-console
    console.log('[RouteConfigurationEdit] updateValidity - child validity=', isRouteValid, {
      title: this.title,
      isReceiver: this.isReceiver,
      cancellationRouteActive: this.cancellationRouteActive,
      troubleRouteActive: this.troubleRouteActive,
    });
    this.lastValidity = isRouteValid;
    this.isValidForm();
  }

  isValidForm() {
    // DEBUG: before applying cron/immediate logic
    // eslint-disable-next-line no-console
    console.log('[RouteConfigurationEdit] isValidForm - start', {
      title: this.title,
      isReceiver: this.isReceiver,
      lastValidity: this.lastValidity,
      immediate: this.routeConfiguration?.immediate,
      cronExpression: this.routeConfiguration?.cronExpression,
      endpointType: this.routeConfiguration?.endpointType,
    });
    let valid = this.lastValidity;
    if (!this.routeConfiguration.immediate) {
      valid = valid && !isNilty(this.routeConfiguration.cronExpression);
    }
    // DEBUG: final validity emitted to parent
    // eslint-disable-next-line no-console
    console.log('[RouteConfigurationEdit] isValidForm - emitting isValidRoute=', valid, {
      title: this.title,
    });
    this.isValidRoute.emit(valid);
  }

  setCancellationRouteStatus(value: boolean) {
    this.changeCancellationRouteStatus.emit(value);
  }
  setTroubleRouteStatus(value: boolean) {
    this.changeTroubleRouteStatus.emit(value);
  }
}
